var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
var defaultSortParam = 'element';
var defaultSortDirection = 'asc';
var NotificacionsDenunciesFilterService = /** @class */ (function (_super) {
    __extends(NotificacionsDenunciesFilterService, _super);
    function NotificacionsDenunciesFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificacionsDenunciesFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('exp', (filter.element ? filter.element.toString() : ''))
            .append('judicial', filter.judicial ? filter.judicial.toString() : '')
            .append('dataIni', filter.dataIni ? filter.dataIni.toJSON() : '')
            .append('dataFi', filter.dataFi ? filter.dataFi.toJSON() : '')
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return NotificacionsDenunciesFilterService;
}(CustomFilterService));
export { NotificacionsDenunciesFilterService };
